import React, { useState, useMemo, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import CustomCard from "../Components/CustomCard";

const CLAMP_LINES = 4;
const TOGGLE_MIN_CHARS = 180;

const HappyStories = () => {
  const { t } = useTranslation();

  const cards = useMemo(
    () => [
      { id: "puffi", imgUrl: "/img/puffi.jpg", title: t("happy-stories.subtitle-1"), body: t("happy-stories.text-1") },
      { id: "picur", imgUrl: "/img/picur.jpg", title: t("happy-stories.subtitle-2"), body: t("happy-stories.text-2") },
      { id: "potyi", imgUrl: "/img/potyi.jpg", title: t("happy-stories.subtitle-3"), body: t("happy-stories.text-3") },
      { id: "blanca", imgUrl: "/img/blanca.jpg", title: t("happy-stories.subtitle-4"), body: t("happy-stories.text-4") },
      { id: "joey", imgUrl: "/img/joey.jpg", title: t("happy-stories.subtitle-5"), body: t("happy-stories.text-5") },
      { id: "lexi", imgUrl: "/img/lexi.jpg", title: t("happy-stories.subtitle-6"), body: t("happy-stories.text-6") },
      { id: "mazsola", imgUrls: ["/img/mazsola.jpg", "/img/mazsola1.jpg", "/img/mazsola2.jpg"], title: t("happy-stories.subtitle-7"), body: t("happy-stories.text-7") },
      { id: "luna", imgUrl: "/img/luna.jpg", title: t("happy-stories.subtitle-8"), body: t("happy-stories.text-8") },
    ],
    [t]
  );

  const [expandedId, setExpandedId] = useState(null);
  const toggle = (id) => setExpandedId((prev) => (prev === id ? null : id));

  const refs = useRef({});
  const setRef = (id) => (el) => (refs.current[id] = el);

  const [baseMinHeight, setBaseMinHeight] = useState(0);

  useEffect(() => {
    const compute = () => {
      const heights = cards.map(({ id }) => refs.current[id]?.offsetHeight || 0);

      const collapsedHeights = cards
        .map(({ id }, idx) => (id !== expandedId ? heights[idx] : 0))
        .filter(Boolean);

      const maxH = collapsedHeights.length ? Math.max(...collapsedHeights) : 0;
      if (maxH !== baseMinHeight) setBaseMinHeight(maxH);
    };

    const tId = setTimeout(compute, 0);

    const onResize = () => {
      clearTimeout(onResize._t);
      onResize._t = setTimeout(compute, 100);
    };
    window.addEventListener("resize", onResize);

    return () => {
      clearTimeout(tId);
      window.removeEventListener("resize", onResize);
      clearTimeout(onResize._t);
    };
  }, [cards, expandedId, baseMinHeight]);

  return (
    <div className="container py-5">
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 align-items-start">
        {cards.map(({ id, imgUrl, imgUrls, title, body }) => {
          const isLong = (body?.length || 0) > TOGGLE_MIN_CHARS;
          const isOpen = expandedId === id;

          return (
            <div key={id} className="col">
              <CustomCard
                ref={setRef(id)}
                className="w-100"
                imgUrl={imgUrl}
                imgUrls={imgUrls}
                title={title}
                body={body}
                cardStyle={
                  !isOpen && baseMinHeight ? { minHeight: baseMinHeight } : undefined
                }
                bodyClampLines={isLong && !isOpen ? CLAMP_LINES : undefined}
              >
                {isLong && (
                  <div className="mt-3 text-center">
                    <Button
                      variant="link"
                      className="p-0"
                      style={{
                        color: "#58c459",
                        fontWeight: 500,
                        textDecoration: "none",
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.textDecoration = "underline")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.textDecoration = "none")
                      }
                      onClick={() => toggle(id)}
                      aria-expanded={isOpen}
                    >
                      {isOpen
                        ? t("common.viewLess", "View Less")
                        : t("common.viewMore", "View More")}
                    </Button>
                  </div>
                )}
              </CustomCard>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HappyStories;
